import React, { useState } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from './Button';
export function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navLinks = [{
    name: 'Services',
    href: '#services'
  }, {
    name: 'Storm Damage',
    href: '#storm-damage'
  }, {
    name: 'Why Us',
    href: '#why-us'
  }, {
    name: 'Reviews',
    href: '#reviews'
  }, {
    name: 'Service Area',
    href: '#service-area'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <header className="sticky top-0 z-50 w-full bg-white border-b border-gray-100 shadow-sm" data-id="element-185">
      <div className="container mx-auto px-4 h-20 flex items-center justify-between" data-id="element-186">
        {/* Logo */}
        <a href="#" className="flex-shrink-0 flex items-center" data-id="element-187">
          <img src="https://cdn.magicpatterns.com/uploads/3SjCcnT1xVm8Bfjy8ivEgu/TXD-Logo-1.jpg" alt="Texas Direct Roofing & Construction" className="h-12 w-auto object-contain" data-id="element-188" />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-8" data-id="element-189">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-tx-deep font-medium hover:text-tx-red transition-colors text-sm" data-id="element-190">
              {link.name}
            </a>)}
        </nav>

        {/* Desktop Actions */}
        <div className="hidden lg:flex items-center gap-6" data-id="element-191">
          <a href="tel:8177753540" className="flex items-center gap-2 text-tx-deep font-bold hover:text-tx-red transition-colors" data-id="element-192">
            <Phone className="w-4 h-4" data-id="element-193" />
            (817) 775-3540
          </a>
          <Button className="bg-tx-red hover:bg-tx-red/90 text-white font-bold px-6 h-12 rounded-lg" data-id="element-194">
            Get My Free Inspection
          </Button>
        </div>

        {/* Mobile Menu Toggle */}
        <button className="lg:hidden p-2 text-tx-deep" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-195">
          {isMobileMenuOpen ? <X className="w-6 h-6" data-id="element-196" /> : <Menu className="w-6 h-6" data-id="element-197" />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="lg:hidden absolute top-20 left-0 w-full bg-white border-b border-gray-100 shadow-lg py-4 px-4 flex flex-col gap-4" data-id="element-198">
          <nav className="flex flex-col gap-4" data-id="element-199">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-tx-deep font-medium text-lg py-2 border-b border-gray-50" onClick={() => setIsMobileMenuOpen(false)} data-id="element-200">
                {link.name}
              </a>)}
          </nav>
          <div className="flex flex-col gap-4 mt-4" data-id="element-201">
            <a href="tel:8177753540" className="flex items-center justify-center gap-2 text-tx-deep font-bold text-lg py-3 bg-gray-50 rounded-lg" data-id="element-202">
              <Phone className="w-5 h-5" data-id="element-203" />
              (817) 775-3540
            </a>
            <Button className="bg-tx-red hover:bg-tx-red/90 text-white font-bold w-full h-12 rounded-lg text-lg" data-id="element-204">
              Get My Free Inspection
            </Button>
          </div>
        </div>}
    </header>;
}